import Vue from 'vue'
import { formatRange, formatFraction } from '@/filters/util'

function formatVolume (v) {
  let unitVolume = Vue.localStorage.get('unitVolume', 'ml')

  if (unitVolume === 'floz') {
    let flozVolume = (v / 29.57).toFixed(1)
    return `${formatFraction(flozVolume)} fl oz`
  } else {
    return `${v} ml`
  }
}

export default function (t) {
  return formatRange(t, formatVolume)
}
